<html>

    <body class="dx-viewport">
       
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="2.5"
            >

                <dx-data-grid 
                    #grideventinvitee
                    id="grideventinvitee"

                    keyExpr="id"
                    [dataSource]="subscriptioninviteelist"  
                    noDataText="No Invitee Listed"     

                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    [showRowLines]="true"
                    [showColumnLines]="false"
                    [showBorders]="true"
                    [repaintChangesOnly]="true"

                    [focusedRowEnabled]="true"
                    [hoverStateEnabled]="true"
                    [autoNavigateToFocusedRow]="true"
          
                    (onRowClick)                ="onrowclick($event)"
                    (onFocusedRowChanged)       ="onrowchange($event)"

                    (onCellPrepared)            ="editorPreparing( $event )" 

                    (onCellHoverChanged)        ="onCellHoverInvitee($event)"

                    (onInitNewRow)              ="onrowadd($event)"

                    width="98%"
                    height="98%"
                >
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-filter-row
                        [visible]="true"
                    >
                    </dxo-filter-row>

                    <dxo-sorting
                        mode="single"> <!-- or "multiple" | "none" -->
                    </dxo-sorting>

                    <dxo-selection
                        mode="single"
                    >
                    </dxo-selection>

                    <dxo-load-panel
                        [enabled]="false">
                    </dxo-load-panel>

                    <dxo-editing 
                        mode="popup"                            
                        [allowUpdating]="true"
                        [allowDeleting]="true"
                        [allowAdding]="true"
                        [useIcons]="true"
                    >
                    </dxo-editing>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-column
                        dataField="id"
                        caption="id"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >
                    </dxi-column>   

                    <dxi-column
                        dataField="whoseparticipant"
                        caption="Whose Guest"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [allowFiltering]="false"
                        [visible]="true"
                        width="19%"

                        groupCellTemplate="cellparticipantname"
                        [groupIndex]="0"
                       
                    >

                        <dxi-validation-rule 
                            type="required"
                            message="Whose Guest">
                        </dxi-validation-rule>

                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                        <div *dxTemplate="let d of 'cellparticipantname'">
                            <div>{{ whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div>
                        </div> 
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 

                    </dxi-column>   

                    <dxi-column
                        dataField="title"
                        caption="Title"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                        <dxi-validation-rule 
                            type="required"
                            message="Please Title">
                        </dxi-validation-rule>

                    </dxi-column>   

                    <dxi-column
                        dataField="lastname"
                        caption="Last Name"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >
                        <dxi-validation-rule 
                            type="required"
                            message="Please Last Name">
                        </dxi-validation-rule>

                    </dxi-column>

                    <dxi-column
                        dataField="firstname"
                        caption="First Name"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                        <dxi-validation-rule 
                            type="required"
                            message="Please First Name">
                        </dxi-validation-rule>

                    </dxi-column>

                    <dxi-column
                        dataField="unitno"
                        caption="Unit No"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="streetno"
                        caption="Street No"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="street"
                        caption="Street"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="suburb"
                        caption="Suburb"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="postcode"
                        caption="Post Code"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="state"
                        caption="State"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="country"
                        caption="Country"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="email"
                        caption="Email"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="mobile"
                        caption="Mobile"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="phone"
                        caption="Land Line"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="diettype"
                        caption="Diet Preference"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="dietary"
                        caption="Diet Notes"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="invitelinkstatus"
                        caption="Invite"
                        [allowEditing]="false" 
                        [allowSorting]="false"

                        [visible]="true"
                    
                        [allowFiltering]="false"
                        [allowHeaderFiltering]="true"

                        width="12%"

                        cellTemplate="cellInviteIcon"
                    >

                        <div *dxTemplate="let data of 'cellInviteIcon'">

                            <container-element [ngSwitch]="data.value">
                               
                                <div *ngSwitchCase="'1'"><i class="fa-solid fa-circle-check fa-2x center"></i></div>

                                <div *ngSwitchCase="'0'"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>

                            </container-element>

                        </div>

                    </dxi-column>

                    <dxi-column
                        dataField="coming"
                        caption="Coming"
                        [allowEditing]="false" 
                        [allowSorting]="false"

                        [visible]="true"
                    
                        [allowFiltering]="false"
                        [allowHeaderFiltering]="true"

                        width="12%"

                        cellTemplate="cellComingIcon"
                    >

                        <div *dxTemplate="let data of 'cellComingIcon'">

                            <container-element [ngSwitch]="data.value">

                                <div *ngSwitchCase=1><i class="fa-solid fa-circle-check fa-2x center"></i></div>

                                <div *ngSwitchCase=0><i class="fa-solid fa-circle-question fa-2x center"></i></div>

                                <div *ngSwitchCase=-1><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>

                            </container-element>

                        </div>

                    </dxi-column>

                    <dxi-column
                        dataField="seatno"
                        caption="Seating"
                        [allowEditing]="false" 
                        [allowSorting]="false"

                        [visible]="true"
                    
                        [allowFiltering]="false"
                        [allowHeaderFiltering]="true"

                        width="12%"

                        cellTemplate="cellSeatIcon"
                    >

                        <div *dxTemplate="let data of 'cellSeatIcon'">

                            <container-element [ngSwitch]="data.value">

                                <div *ngSwitchCase="'-1'"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>

                                <div *ngSwitchDefault><i class="fa-solid fa-circle-check fa-2x center"></i></div>

                            </container-element>

                        </div>

                    </dxi-column>

                    <dxi-column
                        dataField="thankyoulinkid"
                        caption="Thankyou"
                        [allowEditing]="false" 
                        [allowSorting]="false"

                        [visible]="true"
                    
                        [allowFiltering]="false"
                        [allowHeaderFiltering]="true"

                        width="12%"

                        cellTemplate="cellThankyouIcon"
                    >

                        <div *dxTemplate="let data of 'cellThankyouIcon'">

                            <container-element [ngSwitch]="data.value">

                                <div *ngSwitchCase="'0'"><i class="fa-solid fa-circle-xmark fa-2x center"></i></div>

                                <div *ngSwitchDefault><i class="fa-solid fa-circle-check fa-2x center"></i></div>

                            </container-element>

                        </div>

                    </dxi-column>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>

                                <dx-button
                                    text="Add"
                                    icon="refresh" 
                                    (onClick)="inviteeform( $event, 10)"
                                >

                                </dx-button>

                                <dx-button
                                    text="Invitee"
                                    icon="refresh" 
                                    [disabled]="buttondisable"
                                    (onClick)="inviteeform( $event, 20)"
                                >

                                </dx-button>

                                <dx-button
                                    text="Address"
                                    icon="refresh" 
                                    [disabled]="buttondisable"
                                    (onClick)="inviteeform( $event, 30)">

                                </dx-button>

                                <dx-button
                                    text="Contact Details"
                                    icon="refresh" 
                                    [disabled]="buttondisable"
                                    (onClick)="inviteeform( $event, 40)">

                                </dx-button>

                                <dx-button
                                    text="Dietary"
                                    icon="refresh" 
                                    [disabled]="buttondisable"
                                    (onClick)="inviteeform( $event, 50)">

                                </dx-button>

                            </div>
                        </dxi-item>
                    </dxo-toolbar>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                </dx-data-grid>
                
            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="3.0"
            >
                <dx-form 
                    #forminviteenameprofile
                    [(formData)]="formData"
                
                    [showColonAfterLabel]="true"  
                    labelMode="outside"
                    labelLocation="left"
                    [readOnly]="true"

                    

                    width="90%"

                    [colCount]="1"
                >
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Invitee Name Details"
                      
                        [colCount]="5"
                    >
                        <dxi-item
                            dataField="title"

                            [colSpan]="1"

                            [editorOptions]="{  width: 50, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                            
                        >

                            <dxo-label 
                                template="name"
                                text="Title"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="lastname"

                            [colSpan]="2"

                            [editorOptions]="{  width: 180, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                        >

                            <dxo-label 
                                template="name"
                                text="Last Name"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="firstname"

                            [colSpan]="2"

                            [editorOptions]="{  width: 180, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                        >

                            <dxo-label 
                                template="name"
                                text="First Name"
                            >
                            </dxo-label>      

                        </dxi-item>
                        
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Street Address"
                       
                        [colCount]="5"
                    >

                        <dxi-item
                            dataField="unitno"

                            [colSpan]="1"

                            [editorOptions]="{  width: 50, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                       
                    
                        >

                            <dxo-label 
                                template="location"
                                text="Unit No"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="streetno"

                            [colSpan]="1"

                            [editorOptions]="{  width: 50, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                           
                        >

                            <dxo-label 
                                template="location"
                                text="Street No"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="street"

                            [colSpan]="3"

                            [editorOptions]="{  width: 350, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                            
                
                        >

                            <dxo-label 
                                template="location"
                                text="Street"
                            >
                            </dxo-label>      

                        </dxi-item>


                        <dxi-item
                            dataField="suburb"

                            [colSpan]="3"

                            [editorOptions]="{  width: 320, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                
                        >

                            <dxo-label 
                                template="location"
                                text="Suburb"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="postcode"

                            [colSpan]="1"

                            [editorOptions]="{  width: 50, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
            
                        >

                            <dxo-label 
                                template="location"
                                text="Post Code"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="state"

                            [colSpan]="1"

                            [editorOptions]="{  width: 60, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
    
                        >

                            <dxo-label 
                                template="location"
                                text="State"
                            >
                            </dxo-label>      

                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item itemType="empty" ></dxi-item>
                    <dxi-item itemType="empty" ></dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Postal Address"
                        [colCount]="3"
                    >

                        <dxi-item
                            dataField="pobox"

                            [colSpan]="1"

                            [editorOptions]="{  width: 120, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="letter"
                                text="Po Box"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="poboxsuburb"

                            [colSpan]="2"

                            [editorOptions]="{  width: 250, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="letter"
                                text="Suburb"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="poboxpostcode"

                            [colSpan]="1"

                            [editorOptions]="{  width: 120, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="letter"
                                text="Postcode"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="poboxstate"

                            [colSpan]="1"

                            [editorOptions]="{  width: 250, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="letter"
                                text="State"
                            >
                            </dxo-label>      

                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item itemType="empty" ></dxi-item>
                    <dxi-item itemType="empty" ></dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Contact Details"
                        [colCount]="4"
                    >

                        <dxi-item
                            dataField="email"

                            [colSpan]="2"

                            [editorOptions]="{  width: 220, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="email"
                                text="Email"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="mobile"

                            [colSpan]="1"

                            [editorOptions]="{  width: 100, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="mobile"
                                text="Mobile"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="phone"

                            [colSpan]="1"

                            [editorOptions]="{  width: 100, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder"
                    
                        >

                            <dxo-label 
                                template="phone"
                                text="Phone"
                            >
                            </dxo-label>      

                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item itemType="empty" ></dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Dietary Requirements"
                        [colCount]="7"
                    >

                        <dxi-item
                            dataField="diettype"

                            [colSpan]="3"

                            [editorOptions]="{  width: 180, 
                                                height: 40, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemborder" 
                        >

                            <dxo-label 
                                template="food"
                                text="Dietary Preference"
                            >
                            </dxo-label>      

                        </dxi-item>

                        <dxi-item
                            dataField="dietary"
                            editorType="dxTextArea"

                            [colSpan]="4"

                            [editorOptions]="{  width: 335, 
                                                height: 100, 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                            cssClass="dxitemtextarea"

                            
                        >

                            <dxo-label 
                                template="note"
                                text="Notes"
                            >
                            </dxo-label>      

                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <ng-container *ngFor="let label of labelTemplates">
                        <div *dxTemplate="let data of label.name">
                          <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                        </div>
                    </ng-container>
                    <!------------------------------------------------------------------------->

                </dx-form>

            </dxi-item>
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [(visible)]="popupinviteeVisible"
            height="45%"
            width="50%"
            position="center"
        >
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"
    
                [options]="{
                                text: 'Cancel',
                                onClick: cancelClick
                            }"

            >
            </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <div *dxTemplate="let data of 'content'">
                <!------------------------------------------------------------------------->
                <span style="font-size: 16;">Whose Invitee</span>
                <div class="line"></div>
                <!------------------------------------------------------------------------->
                <dx-validation-group #targetOrganiserId>

                    <dx-drop-down-box 
                        [(value)]="organiserid" 
                        valueExpr="id"
                        displayExpr="initial" 
                        placeholder="Select a value..." 
                        [showClearButton]="true" 
                        [dataSource]="whoseguest"

                        label="Whose Guest"
                        labelMode="floating"

                        height="40"
                        width="300"

                        (onOpened) = "dropDownInitOpen( $event )"

                    >
                       
                        <dx-validator>
                            <dxi-validation-rule 
                                type="custom" 
                                [reevaluate]="true"  
                                [validationCallback]="validatetextinput"  
                                message="Whose Guest is required">
                            </dxi-validation-rule>
                        </dx-validator>

                        <div *dxTemplate="let data of 'content'">

                            <dx-data-grid
                                #gridinitial
                                [dataSource]="whoseguest"
                                [columns]="gridColumns"

                                keyExpr="id"

                                [selection]="{ mode: 'single' }"

                                [hoverStateEnabled]="true"
                                
                                [autoNavigateToFocusedRow]="true"
                                [focusedRowEnabled]="true"

                                [height]="265"

                                (onRowClick)="rowclickinitial( $event )"
                            >
                        
                            </dx-data-grid>

                        </div>

                    </dx-drop-down-box>


                </dx-validation-group>

                <br>
                <!------------------------------------------------------------------------->
                <dx-form 
                    #forminviteename
                    [(formData)]="formData"
                    
                    [showColonAfterLabel]="true"  
                    labelMode="outside"
                    labelLocation="left"

                    (onFieldDataChanged)="formDatafldchange( $event )"

                    [colCount]="1"
                >
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Invitee Name Details"
                        [colCount]="3"

                    >
                        <dxi-item
                            dataField="title"
                            editorType="dxSelectBox"

                            [editorOptions]="{  width: 135, 
                                                height: 40, 
                                                placeholder: 'Enter Title', 
                                                inputAttr: { autocomplete: 'chrome-off'},
                                                items: this.inviteetitle, 
                                                value: this.seltitle 
                                            }"

                        >

                            <dxo-label 
                                template="name"
                                text="Title"
                            >
                            </dxo-label>                 

                            <dxi-validation-rule 
                                type="required"
                                message="Title is required"
                            >
                            </dxi-validation-rule>

                        </dxi-item>
                        
                        <dxi-item
                            dataField="lastname"

                            [editorOptions]="{  width: 135, 
                                                height: 40, 
                                                placeholder: 'Enter Lastname', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >

                            <dxo-label 
                                template="name"
                                text="Last Name"
                            >
                            </dxo-label>      

                            <dxi-validation-rule 
                                type="required"
                                message="Lastname is required"
                            >
                            </dxi-validation-rule>

                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            dataField="firstname"

                            [editorOptions]="{  width: 135, 
                                                height: 40, 
                                                placeholder: 'Enter Lastname', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                             }"
                        >

                            <dxo-label 
                                template="name"
                                text="First Name"
                            >
                            </dxo-label> 

                            <dxi-validation-rule 
                                type="required"
                                message="Fistname is required"
                            >
                            </dxi-validation-rule>                 
                            
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                    
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <ng-container *ngFor="let label of labelTemplates">
                        <div *dxTemplate="let data of label.name">
                          <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                        </div>
                    </ng-container>
                    <!------------------------------------------------------------------------->

                </dx-form>
                <!------------------------------------------------------------------------->
            </div>

        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [(visible)]="popupaddressVisible"
            height="95%"
            width="55%"
            position="center"
        >
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Cancel',
                                onClick: cancelClick
                            }"

            >
            </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <dx-box
                direction="col"
                width="98%"
                height="100%"
            >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <dxi-item
                    [ratio]="1.4"
                    class="rectangle"
                >
                    <!------------------------------------------------------------------------->
                    <dx-data-grid 
                        #grideventgoogleaddress
                        id="grideventgoogleaddress"

                        keyExpr="id"
                        [dataSource]="subscriptiongoogleaddresslist"    

                        [allowColumnReordering]="false"
                        [allowColumnResizing]="true"
                        [showRowLines]="true"
                        [showColumnLines]="false"
                        [showBorders]="true"
                        [repaintChangesOnly]="true"

                        [focusedRowEnabled]="true"
                        [hoverStateEnabled]="true"
                        [autoNavigateToFocusedRow]="true"
            
                        width="98%"
                        height="98%"
                    >

                        <dxo-filter-row
                            [visible]="true"
                        ></dxo-filter-row>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="Search..."
                        ></dxo-search-panel>

                        <dxo-selection
                            mode="single"
                        >
                        </dxo-selection>

                        <dxo-load-panel
                            [enabled]="false">
                        </dxo-load-panel>

                        <dxo-editing 
                            mode="row"                            
                            [allowUpdating]="false"
                            [allowDeleting]="false"
                            [allowAdding]="false"
                            [useIcons]="true"
                        >
                        </dxo-editing>
                        <!------------------------------------------------------------------------->        
                        <dxi-column
                            dataField="id"
                            caption="id"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="false"
                            width="19%"
                        >
                        </dxi-column>

                        <dxi-column
                            dataField="streetno"
                            caption="Street No"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="19%"
                        >
                        </dxi-column>

                        <dxi-column
                            dataField="street"
                            caption="Street"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="19%"
                        >
                        </dxi-column>

                        <dxi-column
                            dataField="suburb"
                            caption="Suburb"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="19%"
                        >
                        </dxi-column>

                        <dxi-column
                            dataField="postcode"
                            caption="PostCode"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="19%"
                        >
                        </dxi-column>

                        <dxi-column
                            dataField="state"
                            caption="State"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="19%"
                        >
                        </dxi-column>
                        <!------------------------------------------------------------------------->
                        <dxi-column type="buttons" [width]="50">
                            <dxi-button
                                hint="Transfer Address"
                                icon="fa-solid fa-circle-right fa-beat-fade"
                                [onClick]="transferaddressclick"
                            >
                            </dxi-button>

                        </dxi-column>
                        <!------------------------------------------------------------------------->
                    </dx-data-grid>
                    <!------------------------------------------------------------------------->

                </dxi-item>

                <dxi-item
                    [ratio]="0.05"
                >
                </dxi-item>

                <dxi-item
                    [ratio]="2.0"
                >
                    <!------------------------------------------------------------------------->
                    <div *dxTemplate="let data of 'content'">

                        <dx-form 
                            #forminviteeaddress
                            [(formData)]="formData"
            
                            [showColonAfterLabel]="true"  
                            labelMode="outside"
                            labelLocation="left"
                        
                            (onFieldDataChanged)="formDatafldchange( $event )"
                        >
                            <!------------------------------------------------------------------------->
                            <dxi-item 
                                itemType="group" 
                                caption="Street Address Details"
                                [colCount]="3"
                            >
                                <dxi-item
                                    dataField="unitno"
            
                                    [editorOptions]="{  width: 50, 
                                                        height: 40, 
                                                        placeholder: 'Enter UnitNo', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value:  this.selunitno
                                                    }"
                                >
    
                                    <dxo-label 
                                        template="location"
                                        text="Unit No"
                                    >
                                    </dxo-label> 
        
                                </dxi-item> 

                                <dxi-item
                                    dataField="streetno"

                                    [editorOptions]="{  width: 100, 
                                                        height: 40, 
                                                        placeholder: 'Enter Street No', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value:  this.selstreetno
                                                    }"

                                    [cssClass]="leftposstreetno(1)"
                                
                                >

                                    <dxo-label 
                                        template="location"
                                        text="Street No"
                                    >
                                    </dxo-label> 

                                    <dxi-validation-rule 
                                        type="required"
                                        message="Street No is required"
                                    >
                                    </dxi-validation-rule>
                            
                                </dxi-item> 

                                <dxi-item
                                    dataField="street"

                                    [editorOptions]="{  width: 290, 
                                                        height: 40, 
                                                        placeholder: 'Enter Street Name', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value:  this.selstreet
                                                        
                                                    }"

                                    [cssClass]="leftposstreetno(10)"
                                >

                                    <dxo-label 
                                        template="location"
                                        text="Street"
                                    >
                                    </dxo-label> 

                                    <dxi-validation-rule 
                                        type="required"
                                        message="Street is required"
                                    >
                                    </dxi-validation-rule>
                                
                                </dxi-item>

                                <dxi-item
                                    dataField="suburb"

                                    [editorOptions]="{  width: 160, 
                                                        height: 40, 
                                                        placeholder: 'Enter Suburb', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value:  this.selsuburb
                                                    }"
                                >

                                    <dxo-label 
                                        template="location"
                                        text="Suburb"
                                    >
                                    </dxo-label> 

                                    <dxi-validation-rule 
                                        type="required"
                                        message="Suburb is required"
                                    >
                                    </dxi-validation-rule>
                                            
                                
                                </dxi-item>

                                <dxi-item
                                    dataField="postcode"

                                    [editorOptions]="{  width: 130, 
                                                        height: 40, 
                                                        placeholder: 'Enter PostCode', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value:  this.selpostcode
                                                    }"

                                >

                                    <dxo-label 
                                        template="location"
                                        text="PostCode"
                                    >
                                    </dxo-label> 

                                    <dxi-validation-rule 
                                        type="required"
                                        message="Postcode is required"
                                    >
                                    </dxi-validation-rule>
                                
                                </dxi-item>

                                <dxi-item
                                    dataField="state"

                                    [editorOptions]="{  width: 160, 
                                                        height: 40, 
                                                        placeholder: 'Enter State', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value:  this.selstate
                                                    }"

                                >

                                    <dxo-label 
                                        template="location"
                                        text="State"
                                    >
                                    </dxo-label> 

                                    <dxi-validation-rule 
                                        type="required"
                                        message="State is required"
                                    >
                                    </dxi-validation-rule>
                                
                                </dxi-item>
                                
                            </dxi-item>

                            <dxi-item itemType="empty"></dxi-item>
                            <!------------------------------------------------------------------------->
                            <dxi-item 
                                itemType="group" 
                                caption="Postal Address Details"
                                [colCount]="2"
                            >
                                <dxi-item
                                    dataField="pobox"

                                    [editorOptions]="{  width: 100, 
                                                        height: 40, 
                                                        placeholder: 'Enter PO Box', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value: this.selpobox
                                                    }"

                                    [colSpan]="3"

                                >

                                    <dxo-label 
                                        template="letter"
                                        text="PO Box"
                                    >
                                    </dxo-label> 
                            
                                </dxi-item>

                                <dxi-item
                                    dataField="poboxsuburb"
            
                                    [editorOptions]="{  width: 300, 
                                                        height: 40, 
                                                        placeholder: 'Enter Suburb', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value: this.selposuburb
                                                    }"
            
                                >
        
                                    <dxo-label 
                                        template="letter"
                                        text="Suburb"
                                    >
                                    </dxo-label> 
        
                                </dxi-item>
        
                                <dxi-item
                                    dataField="poboxpostcode"
            
                                    [editorOptions]="{  width: 130, 
                                                        height: 40, 
                                                        placeholder: 'Enter PostCode', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value: this.selpopostcode
                                                    }"
                                >
            
                                    <dxo-label 
                                        template="letter"
                                        text="Post Code"
                                    >
                                    </dxo-label> 
            
                                </dxi-item>

                                <dxi-item
                                    dataField="poboxstate"
            
                                    [editorOptions]="{  width: 160, 
                                                        height: 40, 
                                                        placeholder: 'Enter State', 
                                                        inputAttr: { autocomplete: 'chrome-off'},
                                                        value: this.selpostate
                                                    }"
            
                                >
        
                                    <dxo-label 
                                        template="letter"
                                        text="State"
                                    >
                                    </dxo-label> 
                            
                                </dxi-item>

                            </dxi-item>
                            <!------------------------------------------------------------------------->
                            <ng-container *ngFor="let label of labelTemplates">
                                <div *dxTemplate="let data of label.name">
                                <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                                </div>
                            </ng-container>
                            <!------------------------------------------------------------------------->
                        </dx-form>

                    </div>
                    <!------------------------------------------------------------------------->
                </dxi-item>

            </dx-box>

            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [(visible)]="popupcontactVisible"
            height="45%"
            width="21%"
            position="center"
        >
        <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"
    
                [options]="{
                                text: 'Cancel',
                                onClick: cancelClick
                            }"

            >
            </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <div *dxTemplate="let data of 'content'">

                <dx-form 
                    #forminviteecontact
                    [(formData)]="formData"

                    [showColonAfterLabel]="false"  
                    labelMode="outside"
                    labelLocation="top"

                    (onFieldDataChanged)="formDatafldchange( $event )"

                    [colCount]="1"
                >
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        dataField="email"

                        [editorOptions]="{  width: 300, 
                                            height: 40, 
                                            placeholder: 'Enter Email', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >

                        <dxo-label 
                            template="email"
                            text="Email"
                        >
                        </dxo-label> 

                        <dxi-validation-rule
                            type="email"
                            message="Email is invalid"
                        >
                        </dxi-validation-rule>
                                   
                    </dxi-item> 

                    <dxi-item
                        dataField="mobile"

                        [editorOptions]="{  width: 300, 
                                            height: 40, 
                                            placeholder: 'Enter Mobile', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >

                        <dxo-label 
                            template="mobile"
                            text="Mobile"
                        >
                        </dxo-label> 
                                   
                    </dxi-item> 

                    <dxi-item
                        dataField="phone"
                        
                        [editorOptions]="{  width: 300, 
                                            height: 40, 
                                            placeholder: 'Enter Land Line', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"

                    >

                        <dxo-label 
                            template="phone"
                            text="Phone"
                        >
                        </dxo-label> 
                            
                    </dxi-item> 
                    <!------------------------------------------------------------------------->
                    <ng-container *ngFor="let label of labelTemplates">
                        <div *dxTemplate="let data of label.name">
                          <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                        </div>
                    </ng-container>
                    <!------------------------------------------------------------------------->
                </dx-form>

            </div>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [(visible)]="popupdietVisible"
            height="45%"
            width="31%"
            position="center"
        >
        <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveClick
                            }"
 
             >
            </dxi-toolbar-item>
 
             <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"
    
                [options]="{
                                text: 'Cancel',
                                onClick: cancelClick
                            }"
 
             >
             </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <div *dxTemplate="let data of 'content'">
 
                <dx-form 
                   #forminviteediet
                   [(formData)]="formData"

                   [showColonAfterLabel]="true"  
                   labelMode="outside"
                   labelLocation="left"

                   (onFieldDataChanged)="formDatafldchange( $event )"

                   [colCount]="1"
                >
                   <!------------------------------------------------------------------------->
                   <dxi-item
                       dataField="diettype"
                       editorType="dxSelectBox"

                       [editorOptions]="{  width: 320, 
                                           height: 40, 
                                           placeholder: 'Enter Diet Preference', 
                                           inputAttr: { autocomplete: 'chrome-off'},
                                           items: this.dietlist, 
                                           value: this.seldiet
                                       }"

                   >

                       <dxo-label 
                           template="food"
                           text="Dietary Preference"
                       >
                       </dxo-label>                 

                   </dxi-item>
                   <!------------------------------------------------------------------------->
                   <dxi-item
                       dataField="dietary"
                       editorType="dxTextArea"

                       [editorOptions]="{  width: 320, 
                                           height: 150, 
                                           placeholder: 'Enter Dietary Notes', 
                                           inputAttr: { autocomplete: 'chrome-off'}
                                       }"

                   >
                       <dxo-label 
                           template="note"
                           text="Notes"
                       >
                       </dxo-label>    
                   </dxi-item>
                   <!------------------------------------------------------------------------->
                   <ng-container *ngFor="let label of labelTemplates">
                       <div *dxTemplate="let data of label.name">
                         <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                       </div>
                   </ng-container>
                   <!------------------------------------------------------------------------->
                </dx-form>

            </div>
            <!------------------------------------------------------------------------->
         </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-toast
            [(message)]       =   "toastFileMessage"
            [(visible)]       =   "toastVisible"
            [type]            =   "toasttypeerror"
            [displayTime]     =   "toastdisplaytime"  
            [width]           =   "toastwidth" 
        >
            
            <dxo-position  
            >
                <dxo-at 
                    x="left" 
                    y="top">
                </dxo-at>

                <dxo-offset
                    [x]="toastposX" 
                    [y]="toastposY"
                >
                </dxo-offset>
                
            </dxo-position>

        </dx-toast>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>
